import React, { Component } from 'react';
import logo from '../../assets/images/mathletics-logo.svg';
import backArrow from '../../assets/left-arrow.svg';
import { connect } from 'react-redux';
import { formatLocale } from '../../helpers/utils';

class Logo extends Component {
  render() {
    const locale = formatLocale(this.props.country);
    const heading =  locale === 'en-US' ? 'Math A-Z' : 'Maths A-Z';
    document.title = getTitleLocale(locale)
    const backText = locale.startsWith('es') ? 'Regresar' : 'Back'
    const onBackButtonClick = async () => {
      const backUrl = window.sessionStorage.getItem('RETURN_URL');
      if (backUrl) {
          window.top.location.href = backUrl;
      } else {
          const StudentCentreURL = window._env_.StudentCentreURL;
          window.top.location.href = StudentCentreURL;
      }
    };
    return (
      <div className="logo-container">
        <img className="concept-search-logo" alt="Concept Search Logo" src={logo} />
        <button
          className="btn-default back"
          onClick={onBackButtonClick}
          >
            <img alt="Back Button" width="10" height="10" src={backArrow} />{backText}
        </button>
        <span className='heading'>{heading}</span>
      </div>
    );
  }
} 

function getTitleLocale(locale) {
  switch(true) {
    case locale == "en-US":
      return "Math A-Z - Resources - Mathletics";
    case locale.startsWith('es'):
      return "Glosario matemático - Recursos - Mathletics";
    default:
      return "Maths A-Z - Resources - Mathletics";
  }
}

function mapStateToProps(state){
  return {
      country: state.mathsDictionary.countryFilter
  }
}

export default connect(mapStateToProps)(Logo);
